import React, { useState, useEffect } from 'react';
import { Card, Badge, Typography } from 'antd';
import io from 'socket.io-client';

const { Text } = Typography;

const ConnectionTest = () => {
  const [socketStatus, setSocketStatus] = useState('connecting');
  const [serverUrl, setServerUrl] = useState('');

  useEffect(() => {
    // Get the socket URL
    const getSocketUrl = () => {
      if (process.env.REACT_APP_SOCKET_URL) {
        return process.env.REACT_APP_SOCKET_URL;
      }
      if (process.env.NODE_ENV === 'production') {
        return window.location.origin;
      }
      return 'http://localhost:3001';
    };

    const socketUrl = getSocketUrl();
    setServerUrl(socketUrl);

    // Test connection
    const testSocket = io(socketUrl, {
      timeout: 5000,
      autoConnect: true,
      transports: ['websocket', 'polling']
    });

    testSocket.on('connect', () => {
      console.log('ConnectionTest: Connected to server');
      setSocketStatus('connected');
      testSocket.disconnect();
    });

    testSocket.on('connect_error', (error) => {
      console.error('ConnectionTest: Connection failed:', error);
      setSocketStatus('failed');
      testSocket.disconnect();
    });

    // Cleanup
    return () => {
      if (testSocket) {
        testSocket.disconnect();
      }
    };
  }, []);

  const getStatusColor = (status) => {
    switch (status) {
      case 'connected': return 'green';
      case 'failed': return 'red';
      default: return 'blue';
    }
  };

  const getStatusText = (status) => {
    switch (status) {
      case 'connected': return 'Connected';
      case 'failed': return 'Connection Failed';
      default: return 'Connecting...';
    }
  };

  return (
    <Card size="small" style={{ marginBottom: 16 }}>
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
        <Text>Server Status:</Text>
        <div>
          <Badge 
            color={getStatusColor(socketStatus)} 
            text={getStatusText(socketStatus)}
          />
          <br />
          <Text type="secondary" style={{ fontSize: '12px' }}>
            {serverUrl}
          </Text>
        </div>
      </div>
    </Card>
  );
};

export default ConnectionTest;